// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"7a51aa95","453":"5eee8f7b","772":"42f49263","822":"02b1583c"}[chunkId] + ".chunk.js";
};